import { Grid, Stack, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import ToolsHeader from '../common/ToolsHeader'
import { Helmet } from 'react-helmet'
import OptimizerHeader from './OptimizerHeader'
import LineupSelector from './LineupSelector'
import OutcomesTableWrapper from './OutcomesTableWrapper'
import MobileLineupSelector from './MobileLineupSelector'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Authentication from '../common/Authentication'

const Pick6 = () => {
  const queryClient = new QueryClient();
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <QueryClientProvider client={queryClient}>
      <Authentication app='PICKEM'>
        <Stack sx={{
          fontFamily: 'Inter',
          backgroundColor: '#0A0A0A',
          flexGrow: 1,
          height: '100vh',
          overflowX: 'hidden',
        }}>
          <Helmet>
            <title>Pick'Em Optimizer</title>
            <meta name="description" content="Stokastic Pick 6 Optimizer" />
          </Helmet>
          <ToolsHeader />
          <OptimizerHeader />
          <Grid
            id="optimizer-content-layout"
            container
            spacing={"20px"}
            alignItems={"flex-start"}
            justifyContent={"flex-start"}
            sx={isMobileView ? {
              marginTop: "0px",
              flexDirection: { xs: "column", md: "row" },
              padding: { sx: '0px', md: '0px 20px 20px 20px' },
              '#lineup-selector-wrapper, #outcomes-table-wrapper': {
                paddingTop: '0px'
              },
            } : {
              marginTop: "0px",
              flexDirection: { xs: "column", md: "row" },
              padding: { sx: '0px', md: '0px 20px 20px 20px' },
            }}
          >
            <Grid item sm={12} md={4} id="lineup-selector-wrapper">
              {!isMobileView ? <LineupSelector /> : <MobileLineupSelector />}
            </Grid>
            <Grid container item xs={12} sm={12} md={8} id="outcomes-table-wrapper" sx={{ width: '100% !important', }}>
              <OutcomesTableWrapper />
            </Grid>
          </Grid>
        </Stack>
      </Authentication>

    </QueryClientProvider>
  )
}

export default Pick6